import { render, staticRenderFns } from "./ResidentStatus.vue?vue&type=template&id=44c8357d"
import script from "./ResidentStatus.vue?vue&type=script&lang=ts"
export * from "./ResidentStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports